import React from 'react';
export function Footer() {
  return <footer id="legal" className="bg-navy text-white pt-16 pb-8" data-id="element-187">
      <div className="container mx-auto max-w-[var(--maxw)] px-4" data-id="element-188">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-189">
          {/* Column 1: Company Info */}
          <div className="space-y-6" data-id="element-190">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cw3ea4867NqajmUxwmCcxJ/Logo_-_Company_-_HD.png" alt="COSMO IMAGE AVIATION" className="h-12 brightness-0 invert" data-id="element-191" />
            <div className="space-y-4 text-gray-300" data-id="element-192">
              <p className="font-medium text-white" data-id="element-193">
                COSMO IMAGE AVIATION PTE. LTD.
              </p>
              <p data-id="element-194">Company Reg No: 202312119R</p>
              <p className="text-sm border-l-2 border-teal pl-4" data-id="element-195">
                Content verified against ACRA records (March 2025).
              </p>
            </div>
          </div>

          {/* Column 2: Quick Links (implied from content structure) */}
          <div data-id="element-196">
            <h3 className="text-lg font-bold mb-6 border-b border-white/20 pb-2 inline-block" data-id="element-197">
              Quick Links
            </h3>
            <ul className="space-y-3 text-gray-300" data-id="element-198">
              <li data-id="element-199">
                <a href="/#home" className="hover:text-teal transition-colors" data-id="element-200">
                  Home
                </a>
              </li>
              <li data-id="element-201">
                <a href="/#about" className="hover:text-teal transition-colors" data-id="element-202">
                  About Us
                </a>
              </li>
              <li data-id="element-203">
                <a href="/#services" className="hover:text-teal transition-colors" data-id="element-204">
                  Our Services
                </a>
              </li>
              <li data-id="element-205">
                <a href="/#leadership" className="hover:text-teal transition-colors" data-id="element-206">
                  Leadership
                </a>
              </li>
              <li data-id="element-207">
                <a href="/#locations" className="hover:text-teal transition-colors" data-id="element-208">
                  Locations
                </a>
              </li>
              <li data-id="element-209">
                <a href="/#contact" className="hover:text-teal transition-colors" data-id="element-210">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Legal */}
          <div data-id="element-211">
            <h3 className="text-lg font-bold mb-6 border-b border-white/20 pb-2 inline-block" data-id="element-212">
              Legal Information
            </h3>
            <div className="space-y-4" data-id="element-213">
              <details className="group" data-id="element-214">
                <summary className="cursor-pointer font-medium hover:text-teal transition-colors list-none flex items-center justify-between" data-id="element-215">
                  <span data-id="element-216">Privacy Policy</span>
                  <span className="text-teal group-open:rotate-180 transition-transform" data-id="element-217">
                    +
                  </span>
                </summary>
                <div className="pt-4 text-sm text-gray-300 space-y-2 pl-4 border-l border-white/10 mt-2" data-id="element-218">
                  <p data-id="element-219">
                    COSMO IMAGE AVIATION PTE. LTD. is committed to protecting
                    your privacy. This Privacy Policy explains how we collect,
                    use, and safeguard your information when you visit our
                    website or contact us.
                  </p>
                  <p data-id="element-220">
                    We collect personal information that you voluntarily provide
                    to us when you contact us through our website. We use this
                    information solely for the purpose of responding to your
                    inquiries and providing our services.
                  </p>
                  <p data-id="element-221">
                    We do not sell, trade, or otherwise transfer your personally
                    identifiable information to outside parties except as
                    necessary to provide our services or as required by law.
                  </p>
                </div>
              </details>

              <details className="group" data-id="element-222">
                <summary className="cursor-pointer font-medium hover:text-teal transition-colors list-none flex items-center justify-between" data-id="element-223">
                  <span data-id="element-224">Terms of Use</span>
                  <span className="text-teal group-open:rotate-180 transition-transform" data-id="element-225">
                    +
                  </span>
                </summary>
                <div className="pt-4 text-sm text-gray-300 space-y-2 pl-4 border-l border-white/10 mt-2" data-id="element-226">
                  <p data-id="element-227">
                    By accessing this website, you agree to be bound by these
                    Terms of Use, all applicable laws and regulations, and agree
                    that you are responsible for compliance with any applicable
                    local laws.
                  </p>
                  <p data-id="element-228">
                    All content on this website is the property of COSMO IMAGE
                    AVIATION PTE. LTD. and is protected by copyright and other
                    intellectual property laws.
                  </p>
                  <p data-id="element-229">
                    We reserve the right to modify or discontinue any aspect of
                    this website at any time without notice.
                  </p>
                </div>
              </details>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400" data-id="element-230">
          <p data-id="element-231">© 2025 COSMO IMAGE AVIATION PTE. LTD. All Rights Reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-232">
            <a href="#" className="hover:text-white transition-colors" data-id="element-233">
              Privacy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-234">
              Cookies
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-235">
              Legal
            </a>
          </div>
        </div>
      </div>
    </footer>;
}